module.exports = function() {
  return new Worker(__webpack_public_path__ + "0e58db5c1e212e0bdfe1.worker.js");
};